import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { bool, oneOf, shape, string } from 'prop-types'

import Button from 'views/components/atoms/Button'
import IconCaretRight from 'views/components/atoms/Icon/IconCaretRight'
import ButtonWithIcon from 'views/components/molecules/ButtonWithIcon'

import CartForm from './CartForm'

const ProductAction = props => {
  const {
    hasAddToCartButton,
    mobile,
    productId,
    productUrl,
    showProductDetailLink,
    size,
  } = props
  const ButtonComponent = mobile ? ButtonWithIcon : Button

  const buttonProps = {
    name: `view-product-${productId}-${mobile ? 'mobile' : 'laptop'}`,
    href: productUrl,
    'data-clientside-hook': 'productDetailButton',
    style: 'buttonGhost',
  }

  if (mobile) {
    buttonProps.icon = <IconCaretRight />
    delete buttonProps.style
  }
  const productActionWrapperClassname = classNames(
    'o-SearchProductListItem__ProductAction',
    {
      'l-flex@medium l-flex--justify-content--end ': size === 'small',
    }
  )

  return (
    <div className={productActionWrapperClassname}>
      {showProductDetailLink && (
        <div
          className={classNames(
            'o-SearchProductListItem__ProductAction__button-wrapper',
            {
              'u-margin--right u-hidden@small-tiny': hasAddToCartButton,
            }
          )}
          data-qa-id="product-details-button"
        >
          <ButtonComponent {...buttonProps}>
            <span className="u-no-wrap">
              <Trans id="general.button.label.productLink" />
            </span>
          </ButtonComponent>
        </div>
      )}
      {hasAddToCartButton && <CartForm {...props} />}
    </div>
  )
}

ProductAction.propTypes = {
  ...CartForm.propTypes,
  productId: string.isRequired,
  productUrl: string.isRequired,
  hasAddToCartButton: bool,
  mobile: bool,
  showProductDetailLink: bool,
  // `omit` cannot handle it
  mountPoints: shape({}),
  publicRuntimeConfig: shape({}),
  stockStatus: shape({}),
  size: oneOf(['small', 'large']),
}

ProductAction.defaultProps = {
  ...CartForm.defaultProps,
  hasAddToCartButton: false,
  mobile: false,
  showProductDetailLink: false,
  size: 'large',
}

export default ProductAction
